module.exports = __webpack_public_path__ + "img/invoices.aaf0f753.svg";